import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/Header";
import { apiErr } from "../../lib/format";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || "Login failed.");
    } finally { setLoading(false); }
  };

  const field = "w-full rounded-lg border border-brand-hairline px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-brand-emerald";

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-5 paper-grain">
      <div className="w-full max-w-sm rounded-2xl bg-brand-cream p-8 shadow-2xl">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-6 flex items-center justify-center gap-2 text-brand-emerald">
          <Lock className="h-4 w-4" /><span className="text-sm font-semibold uppercase tracking-wider">Admin Access</span>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-sm font-medium text-brand-ink" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="text-sm font-medium text-brand-ink" htmlFor="admin-password">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 rounded-xl bg-brand-emerald px-6 py-3 font-semibold text-brand-cream hover:bg-brand-emeraldHover disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
